/*
 src/reducers/rootReducer.js
*/
import { combineReducers } from 'redux'
import knowledgeBase from './knowledgeBaseReducer'
export default combineReducers({
  knowledgeBase
})
